import styled from 'styled-components';
import { normalizeHeight } from '../../../utils/normalize';

export const MasterContainer = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  height: 100%;
`;

export const ExpandContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-right: 8px;
  padding-left: 8px;
  border-radius: 8px;
`;

export const ExpandContainerTop = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const ExpandContainerBottom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
`;

export const ExpandIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  cursor: pointer;
`;

export const ExpandArrow = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0px 24px 24px;
  gap: 16px;
  height: 100%;
`;

export const InnerTopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 319px;
`;

export const InnerBottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const Icon = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 32px;
  z-index: 2;
`;

export const FollowText = styled.h1`
  font-size: 14px;
  color: rgba(110, 48, 232, 1);
  font-weight: 600;
  font-family: Inter-Bold;
  cursor: pointer;
`;

export const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  max-width: 319px;
  word-wrap: break-word;
`;

export const Description = styled.p`
  font-size: 12px;
  color: rgba(27, 27, 27, 1);
  font-family: Inter-Regular;
  font-weight: 400;
  width: 319px;
  max-height: 200px;
  overflow: scroll;
`;

export const TranslateContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const ShowMore = styled.p`
  font-size: 12px;
  color: rgba(27, 27, 27, 1);
  font-family: Inter-Bold;
  font-weight: 600;
  cursor: pointer;
  width: fit-content;
`;

export const HideTagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const Tag = styled.p`
  font-size: 12px;
  color: rgba(110, 48, 232, 1);
  font-family: Inter-Bold;
  font-weight: 600;
  cursor: pointer;
  overflow: scroll;
  max-height: 100px;
`;

export const CommentSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(218, 218, 218, 1);
`;

export const CommentPlaceholder = styled.input`
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  font-family: Inter-Regular;
  font-weight: 400;
  background-color: transparent;
  border: none;
  outline: none;
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: 240px;
  // height: ${normalizeHeight(400)};
  gap: 8px;
  overflow: scroll;
  max-width: 319px;
  word-wrap: break-word;
`;

export const HorizontalIconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const IconsDupla = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  cursor: pointer;
`;

